const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function listNebs() {
  const res = await fetch(`${API}/api/nebs`);
  if (!res.ok) throw new Error('nebs fetch failed');
  return res.json(); // { nebs: [...] }
}

export async function getNeb(id) {
  const res = await fetch(`${API}/api/nebs/${id}`);
  if (!res.ok) throw new Error('neb fetch failed');
  return res.json(); // { neb, members }
}

export async function applyNeb(nebId, idToken) {
  const res = await fetch(`${API}/api/nebs/${nebId}/apply`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}` },
  });
  return res.json(); // { appId, message, status, decided }
}

export async function respondNeb(nebId, appId, answer, idToken) {
  const res = await fetch(`${API}/api/nebs/${nebId}/apply/${appId}/respond`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ answer }),
  });
  return res.json(); // { message, status, decided, suggestedNeb? }
}

export async function getMyNebs(idToken) {
  const res = await fetch(`${API}/api/my/nebs`, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!res.ok) throw new Error('my nebs fetch failed');
  return res.json(); // { memberships: [...] }
}
